import { symbol } from "./symbol.js";
<ebay-icon ...input _name="checkbox-checked-24" _size="24" _type="icon" _themes=symbol/>